// removed by extract-text-webpack-plugin
module.exports = {"scroller":"Scroller-m__scroller___2AOxu","scroller_wrapper":"Scroller-m__scroller_wrapper___1Zdwh","scrollerWrapper":"Scroller-m__scroller_wrapper___1Zdwh","scroller_dots":"Scroller-m__scroller_dots___BQYhV","scrollerDots":"Scroller-m__scroller_dots___BQYhV","scroller_dot":"Scroller-m__scroller_dot___3cYK0","scrollerDot":"Scroller-m__scroller_dot___3cYK0","scroller_dot__active":"Scroller-m__scroller_dot__active___2ylcN","scrollerDotActive":"Scroller-m__scroller_dot__active___2ylcN","scroller_dotInner":"Scroller-m__scroller_dotInner___Lqup-","scrollerDotInner":"Scroller-m__scroller_dotInner___Lqup-"};


//////////////////
// WEBPACK FOOTER
// ./components/scroller/Scroller.m.sass
// module id = BXVd
// module chunks = 0